import axios from 'axios';
import { API_URL } from '../config';

export const getDashboardForDepartmentData = () => {
	const URL = `${API_URL}DashboardAttendanceDetails`;
	console.log(URL);
	return axios.get(URL);
};

export const getDashboardForDepartmentAttendanceBySectionwiseData = (
	sectionName: string,
	month: string,
	year: string,
) => {
	const URL = `${API_URL}DashboardAttendanceForHeadOffice`;
	console.log('API URL:', URL);
	console.log('Request params:', { sectionName, currentmonth: month, year });
	return axios.get(URL, {
		params: {
			sectionName,
			currentmonth: month,
			year,
		},
	});
};
